import React from 'react';
import {Field} from 'redux-form';
import {View} from 'react-native';

import {BaseField} from '../../../shared/components/baseField';
import {useDeviceSize, DeviceSize} from '../../../shared/theme/helpers';
import {useStyles} from '../../../shared/hooks/styles';
import {CountDownTimer} from '../components/countDownTimer';
import {sendCodeResponseSelector} from '../../../redux/selectors/login';
import {useSelector} from 'react-redux';
import {defaults} from '../../../shared/constants/defaults';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';

const countdownTimerContainerWidthDesktop = 320;
const formWidthDesktop = 374;

export const SmsFields = ({onRefresh, onSubmit}: {onRefresh: () => void; onSubmit: (e?: any) => void}) => {
  const deviceSize = useDeviceSize();
  const sendCodeResponse = useSelector(sendCodeResponseSelector());
  const isDesktop = useIsDesktop();
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      eyeSubContainer: {
        width: 24,
        height: 16,
        marginBottom: 5,
      },
      eye: {
        color: theme.color.textColor,
      },
      fieldContainer: {
        position: 'relative',
      },
      eyeContainer: {
        width: 24,
        height: 16,
        position: 'absolute',
        right: 0,
        bottom: deviceSize === DeviceSize.desktop ? 10 : 20,
      },
      countDownContainer: mediaOnly(DeviceSize.desktop, {
        alignSelf: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        width: countdownTimerContainerWidthDesktop,
      }),
    };
  });

  return (
    <>
      <View style={styles.fieldContainer}>
        <Field
          component={BaseField}
          label='Код из SMS'
          type='digits'
          maxLength={defaults.smsCodeLength}
          name='smsCode'
          onSubmitEditing={onSubmit}
          style={isDesktop ? {width: formWidthDesktop} : undefined}
          autoFocus
        />
        <View style={styles.countDownContainer}>
          <CountDownTimer
            onRefresh={() => {
              onRefresh();
            }}
            until={sendCodeResponse?.resendCountdown || 300}
          />
        </View>
      </View>
    </>
  );
};
